import React, { ComponentType } from 'react';
import loadableLib, { DefaultComponent } from '@loadable/component';
import dynamic, { LoadableBaseOptions, Loader } from 'next/dynamic';

// component for migration to nextjs
// unused import will be removed on compilation level

// preload is an undocumented feature in nextjs
// https://github.com/vercel/next.js/blob/6d98b4fb4315dec1badecf0e9bdc212a4272b264/packages/next/shared/lib/loadable.js#L156
type LoadableComponent<P> = ComponentType<P> & { preload: () => Promise<void> };

function loadable<P = {}>(
  loader: Loader<P>,
  options?: LoadableBaseOptions<P>,
): LoadableComponent<P> {
  if (__APP__ === 'marketplace') {
    return dynamic(loader, options) as LoadableComponent<P>;
  }
  const LoadingComponent = options?.loading;

  const loadableComponent = loadableLib(
    loader as () => Promise<DefaultComponent<P>>,
    options && {
      ssr: options.ssr,
      fallback: LoadingComponent && <LoadingComponent />,
    },
  );
  loadableComponent.preload = () =>
    loadableComponent.load().then(() => undefined);

  return loadableComponent as unknown as LoadableComponent<P>;
}

export { loadable };
